import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'

export default function ScrollToTop() {
    const { pathname } = useLocation()
    const primeiraRender = useRef(true)

    useEffect(() => {
        window.scrollTo(0, 0)
        /* Numa SPA a navegação não muda o foco: para quem usa leitor de ecrã, mudar
           de página não anuncia nada. Mover o foco para o <main> resolve isso — mas
           NÃO no primeiro carregamento: aí o <main> já é o ponto de partida e roubar-lhe
           o foco faria o primeiro Tab saltar o skip-link e o header. */
        if (primeiraRender.current) {
            primeiraRender.current = false
            return
        }
        const main = document.getElementById('main')
        if (main) main.focus({ preventScroll: true })
    }, [pathname])

    return null
}
